import React from 'react';

const OrderCompleteForm = ({ translations, fetching, submitStatus }) => {
  return (
    <div className="tw-py-5">
      {submitStatus === 'success' && <h3 className="tw-text-2xl tw-mb-5 tw-text-center">{!fetching && translations[0].i18n.order.complete}</h3>}
    </div>
  );
};

export default OrderCompleteForm;